import TransfersList from "./TransfersList";

export default {
    list: TransfersList,
};
